/**
 * File: add-to-cart-popup.js
 *
 * Optional popop triggered by `add to cart` actions.
 */

// Make sure everything is loaded first.
if (
	( 'complete' === document.readyState ||
		'loading' !== document.readyState ) &&
	! document.documentElement.doScroll
) {
	flynnAddToCartPopup();
} else {
	document.addEventListener( 'DOMContentLoaded', flynnAddToCartPopup );
}

/**
 * Kick off our popup functions.
 */
function flynnAddToCartPopup() {
	const cartPopupScreen = document.querySelector( '.cart-popup-screen' );
	const addToCartButtons = document.querySelectorAll( '.add_to_cart_button' );
	if ( ! cartPopupScreen || ! addToCartButtons ) {
		return;
	}
	const neverAgain = document.querySelector( '.never-again' );
	const cartPopupClose = document.querySelector( '.cart-popup-close' );
	const removesPopupWithSlug = neverAgain.getAttribute( 'data-removes' );

	const minProductValue = 25.0;

	const cartPopupContainer = document.querySelector(
		'.cart-popup-container'
	);

	neverAgain.addEventListener( 'click', activateNeverAgain );
	cartPopupClose.addEventListener( 'click', closeCartPopup );
	cartPopupScreen.addEventListener( 'click', closeCartPopup );
	document.body.addEventListener( 'keydown', closeCartPopupOnEscape );

	/**
	 * Close everything when we hit the escape key.
	 *
	 * @param {Object} event The event trigger.
	 */
	function closeCartPopupOnEscape( event ) {
		if ( 27 === event.keyCode ) {
			closeCartPopup();
		}
	}

	/**
	 * Handle requests to never show the add to cart popup again.
	 */
	function activateNeverAgain() {
		localStorage.setItem( 'popup-never-again', removesPopupWithSlug );

		closeCartPopup();
	}

	/**
	 * Handle closing the add to cart popup.
	 */
	function closeCartPopup() {
		cartPopupContainer.classList.remove( 'is-visible' );
		cartPopupScreen.classList.remove( 'is-visible' );
		cartPopupContainer.setAttribute( 'aria-hidden', true );
	}

	jQuery( 'body' ).on(
		'added_to_cart',
		function ( event, fragments, cartHash, button ) {
			const productPrice = button.data( 'product_price' ); // Get the product price
			const popupNeverAgain = localStorage.getItem( 'popup-never-again' );

			if (
				popupNeverAgain !== removesPopupWithSlug &&
				productPrice &&
				parseFloat( productPrice ) >= minProductValue
			) {
				openCartPopup();
			}
		}
	);

	/**
	 * Handle opening the add to cart popup overlay.
	 */
	function openCartPopup() {
		cartPopupContainer.classList.add( 'is-visible' );
		// addToCartButtons.classList.add( 'is-visible' );
		cartPopupScreen.classList.add( 'is-visible' );

		cartPopupContainer.setAttribute( 'aria-hidden', false );
		// addToCartButtons.setAttribute( 'aria-expanded', true );
	}
}
